module.exports = __webpack_public_path__ + "img/Passport.c1be3303.svg";